/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { css } from 'styled-components';

import { createResponsiveGeneralStyle, createResponsiveSpacingStyle, getColor } from '../../utils';
import type { Colors, ResponsiveSpacing } from '../../utils/types';

export type HeadingVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type HeadingProps = {
  testId?: string;
  style?: object;
  /** Applies the Heading style. */
  styleAs?: HeadingVariants;
  marginTop?: ResponsiveSpacing;
  marginBottom?: ResponsiveSpacing;
  marginRight?: ResponsiveSpacing;
  marginLeft?: ResponsiveSpacing;
  color?: Colors;
  textAlign?: 'left' | 'right' | 'center';
  fontStyle?: 'normal' | 'italic';
  children: React.ReactNode;
};

export const Headings = ({ props }: any) => css<HeadingProps>`
  color: ${props => getColor(props.color ?? 'black90')};
  margin-top: 0;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  ${props => props.marginTop && `${createResponsiveSpacingStyle('margin-top', props.marginTop)}`};
  ${props => props.marginRight && `${createResponsiveSpacingStyle('margin-right', props.marginRight)}`};
  ${props => props.marginBottom && `${createResponsiveSpacingStyle('margin-bottom', props.marginBottom)}`};
  ${props => props.marginLeft && `${createResponsiveSpacingStyle('margin-left', props.marginLeft)}`};
  ${props => props.textAlign && createResponsiveGeneralStyle('text-align', props.textAlign)};
  ${props => props.fontStyle && `font-style: ${props.fontStyle}`};
`;
